export const DEFAULT_BASE = 'http://localhost'
export const AUTH_CODE_PARAM = 'sid'
export const DEFAULT_API_VERSION = '2021-06-07'
export const REQUEST_TAG_PREFIX = 'sanity.sdk.auth'
